import { Component, Input, OnInit } from '@angular/core';
import { IGarbageCollectorStatistic } from '../../interfaces/garbage-collector-statistic.interface';
import { bytesToKiloBytes } from 'src/app/shared/utils/utils';

@Component({
    standalone: false,
    selector: 'app-garbage-collector-statistic',
    templateUrl: './garbage-collector-statistic.component.html',
    styleUrls: ['./garbage-collector-statistic.component.scss']
})
export class GarbageCollectorStatisticComponent implements OnInit {
    @Input()
    garbageCollectorStatistic: IGarbageCollectorStatistic;

    bytesToKiloBytes = bytesToKiloBytes;

    constructor() {}

    ngOnInit(): void {}
}
